























































































































import { dateFormat } from "@/utils/timeFormat";
import {
  getStoreInfoApi,
  editStoreInfoApi,
  editStoreInfoInter,
} from "@/api/store";
import imageUploader from "@/components/imageUploader.vue";
import videoUploader from "@/components/videoUploader.vue";
import mapDialog from "./mapDialog.vue";
import previewDialog from "./previewDialog.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {
    imageUploader,
    videoUploader,
    mapDialog,
    previewDialog,
  },
})
export default class extends Vue {
  storeInfo = {
    org_name: "",
    effective_time: "",
    subject: [] as any[],
    visit: 0,
  };
  form = {
    address: {
      city: "",
      city_id: 0,
      province: "",
      province_id: 0,
      district: "",
      district_id: 0,
      address_info: "",
      x_point: "",
      y_point: "",
    },
    cover_image: "",
    cover_image_url: "",
    video: "",
    video_url: "",
  };
  rules = {
    address: [{ required: true, message: "请选择地址", trigger: "change" }],
    cover_image: [
      { required: true, message: "请选择门店封面", trigger: "change" },
    ],
  };
  created() {
    getStoreInfoApi().then((res: any) => {
      this.storeInfo = {
        org_name: res.data.org_name,
        effective_time: dateFormat(
          "YYYY-mm-dd",
          new Date(res.data.effective_time * 1000)
        ),
        subject: res.data.subject,
        visit: res.data.visit,
      };
      this.form = {
        address: {
          city: res.data.city_name,
          city_id: res.data.city,
          province: res.data.province_name,
          province_id: res.data.province,
          district: res.data.district_name,
          district_id: res.data.district,
          address_info: res.data.address,
          x_point: res.data.x_point,
          y_point: res.data.y_point,
        },
        cover_image: res.data.image,
        cover_image_url: res.data.image_url,
        video: res.data.video,
        video_url: res.data.video_url,
      };
    });
  }
  handleAddressChange(data: any) {
    this.form.address = data;
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          const option: editStoreInfoInter = {
            city_id: this.form.address.city_id,
            province_id: this.form.address.province_id,
            district_id: this.form.address.district_id,
            address_info: this.form.address.address_info,
            x_point: String(this.form.address.x_point),
            y_point: String(this.form.address.y_point),
            image: this.form.cover_image,
          };
          if (this.form.video) {
            option.video = this.form.video;
          }
          editStoreInfoApi(option).then((res: any) => {
            this.$message({
              type: "success",
              message: "修改成功",
            });
          });
        }
      }
    );
  }
}
